export default "__VITE_ASSET__DKkt0uTz__"